/* Pokitrio-Redesign: „Mehr laden“ auf der Kategorieseite (Plan 4 Task 6, sections/main-collection.liquid).

   * Der Button ist ein normaler Link auf die naechste Seite (Fallback ohne JS). Mit JS holt ein Klick dieselbe URL
     ueber die Section-Rendering-API (?section_id=<Section>&page=n, Filter und Sortierung stecken schon in der URL),
     haengt die Karten aus [data-pkt-raster] an das Raster an und setzt den Link auf die uebernaechste Seite bzw.
     entfernt ihn auf der letzten Seite.
   * „X von Y“ steht in einer aria-live-Region (data-pkt-mehr-stand), Vorlage in data-pkt-vorlage ([S] = X).
   * Fokus: auf den Namen der ersten neuen Karte (preventScroll: die neuen Karten erscheinen dort, wo der Button war).
   * Doppelte ids: ids in den neuen Karten werden entfernt (die Karten selbst haben keine; der Variantendialog
     ist ein einziger globaler Dialog in assets/pkt-card.js, der per Delegation auch neue Karten bedient).
   * Fehler: sichtbare Meldung (data-pkt-mehr-fehler, role="alert"); der naechste Klick folgt dann dem normalen Link.
   * Nach dem Nachladen setzt history.replaceState den page-Parameter der zuletzt geladenen Seite in die Adresse
     (Filter und Sortierung bleiben, kein neuer Verlaufseintrag).
   * Strg/Cmd/Shift/Alt-Klick und Mittelklick bleiben normale Links (neuer Tab).
   * Nach einem Filterwechsel ersetzt Impact die ganze Section; der Klick-Handler haengt am document und gilt weiter.
   * Nebenbei (Handy): Die Sprach-Chips sind eine wischbare Zeile. Nach dem Laden und nach jedem Filterwechsel
     (MutationObserver auf der Section) wird der erste aktive Chip in den sichtbaren Bereich geschoben.
   * Screenreader: Impact ersetzt beim Filterwechsel die ganze Section, eine Live-Region darin wuerde nicht angesagt.
     Deshalb legt das Skript eine dauerhafte Live-Region am body an (sr-only, aria-live="polite") und schreibt nach
     jedem Neurendern die neue Anzahl aus [data-pkt-ansage] hinein („X Produkte“ bzw. „X von Y Produkten“).
     Der Observer hoert nur auf direkte Kinder der Section: „Mehr laden“ haengt tiefer an und loest keine zweite
     Ansage aus (das meldet seine eigene Region). Beim ersten Laden wird nichts angesagt.
   * Sortierung unter 1000 px: Impacts Popover haengt sich beim Oeffnen an den body (Popover.shouldAppendToBody),
     das listbox:change der Option erreicht <facet-sort-by> dann nicht. In diesem Fall loest das Skript dasselbe
     facet:update aus wie Impacts FacetSortBy (sort_by setzen, page entfernen, section_id aus der Popover-id).
     Liegt der Popover noch in <facet-sort-by> (Desktop), macht Impact es selbst. */
(() => {
  if (window.pktMehrLaden) return;
  window.pktMehrLaden = true;

  const zeigeAktiveChips = (wurzel) => {
    wurzel.querySelectorAll('.pkt-kbar__chips').forEach((leiste) => {
      if (leiste.scrollWidth <= leiste.clientWidth) return;
      const an = leiste.querySelector('.pkt-kchip--an');
      const li = an && an.closest('li');
      if (!li || li === leiste.firstElementChild) return;
      leiste.scrollLeft = Math.max(0, li.offsetLeft - leiste.offsetLeft - 16);
    });
  };
  let region = null;
  const stelleRegion = () => {
    if (region) return;
    region = document.createElement('p');
    region.className = 'sr-only';
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('data-pkt-kol-ansage', '');
    document.body.append(region);
  };
  const sagAn = (sektion) => {
    const quelle = sektion.querySelector('[data-pkt-ansage]');
    const text = quelle && quelle.dataset.pktAnsage;
    if (!text) return;
    stelleRegion();
    // leeren und verzoegert setzen, damit auch ein gleichlautender Text erneut angesagt wird
    region.textContent = '';
    setTimeout(() => { region.textContent = text; }, 120);
  };
  const beobachte = () => {
    document.querySelectorAll('.shopify-section--main-collection').forEach((sektion) => {
      stelleRegion(); // vor der ersten Aenderung im DOM, sonst sagen manche Screenreader die erste Meldung nicht an
      zeigeAktiveChips(sektion);
      new MutationObserver(() => {
        zeigeAktiveChips(sektion);
        sagAn(sektion);
      }).observe(sektion, { childList: true });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachte);
  else beobachte();

  document.addEventListener('listbox:change', (e) => {
    const pop = e.target.closest && e.target.closest('x-popover[id^="popover-sort-by-"]');
    if (!pop || e.target.closest('facet-sort-by')) return;
    const sektionId = pop.id.replace('popover-sort-by-', '');
    if (!document.getElementById('shopify-section-' + sektionId)) return;
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.detail.value);
    url.searchParams.set('section_id', sektionId);
    url.searchParams.delete('page');
    pop.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url } }));
  });

  document.addEventListener('click', async (e) => {
    const link = e.target.closest('[data-pkt-mehr-link]');
    if (!link) return;
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (link.dataset.pktFehler) return;

    const box = link.closest('[data-pkt-mehr]');
    const sektion = link.closest('.shopify-section');
    const raster = sektion && sektion.querySelector('[data-pkt-raster]');
    if (!box || !raster) return;
    e.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;

    const stand = box.querySelector('[data-pkt-mehr-stand]');
    const fehler = box.querySelector('[data-pkt-mehr-fehler]');
    const url = new URL(link.href, location.href);
    url.searchParams.set('section_id', sektion.id.replace('shopify-section-', ''));

    link.setAttribute('aria-busy', 'true');
    if (fehler) fehler.hidden = true;

    try {
      const antwort = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!antwort.ok) throw new Error('HTTP ' + antwort.status);
      const doc = new DOMParser().parseFromString(await antwort.text(), 'text/html');
      const quelle = doc.querySelector('[data-pkt-raster]');
      const karten = quelle ? Array.from(quelle.children) : [];
      if (!karten.length) throw new Error('keine Karten');

      const neu = karten.map((karte) => {
        const kopie = document.importNode(karte, true);
        kopie.removeAttribute('id');
        kopie.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        return kopie;
      });
      raster.append(...neu);

      if (stand && box.dataset.pktVorlage) {
        stand.textContent = box.dataset.pktVorlage.replace('[S]', String(raster.children.length));
      }

      // Adresse auf die zuletzt geladene Seite setzen (Filter und Sortierung bleiben, section_id kommt nicht hinein):
      // Neuladen oder Zurueck vom Produkt landet wieder auf dieser Seite.
      const seite = url.searchParams.get('page');
      if (seite) {
        const adresse = new URL(location.href);
        adresse.searchParams.set('page', seite);
        history.replaceState(history.state, '', adresse.toString());
      }

      const ziel = neu[0].querySelector('.pkt-card__name');
      if (ziel) ziel.focus({ preventScroll: true });

      const weiter = doc.querySelector('[data-pkt-mehr-link]');
      if (weiter) {
        link.href = weiter.getAttribute('href');
        link.removeAttribute('aria-busy');
      } else {
        link.remove();
      }
    } catch (err) {
      link.removeAttribute('aria-busy');
      link.dataset.pktFehler = '1';
      if (fehler) fehler.hidden = false;
    }
  });
})();
